import { Icon } from "semantic-ui-react";
import { options, optionsAsLabel, optionsForDate } from "../GanttInfoRenderer";
import { AbstractInfoRenderer } from "./AbstractInfoRenderer";

export class FlightInfoRenderer extends AbstractInfoRenderer {

    static defaultProps = {
        entityName: "Flight"
    }

    renderFlight(entity: any) {
        const ed = this.getEntityDescriptor();
        return entity ? <div className="flex-container-row flex-center flex-wrap gap3">
            {ed.getField("priority").renderField(entity, options)}
            {entity.name && ed.getField("departure").renderField(entity, options)}
            {ed.getField("name").renderField(entity, optionsAsLabel)}
            {ed.getField("date").renderField(entity, optionsForDate)}
            {ed.getField("schengen").renderField(entity, options)}
            {ed.getField("parking").renderField(entity, options)}
            {ed.getField("lastKnownDateType").renderField(entity, options)}
            {ed.getField("origin").renderField(entity, options)}
            {ed.getField("destination").renderField(entity, options)}
            {ed.getField("comment").renderField(entity, options)}
            {ed.getField("passengersNo").renderField(entity, options)}
            {ed.getField("passengerWithDisabilities").renderField(entity, options)}
            {ed.getField("onHold").renderField(entity, options)}
        </div> : null;
    }

    renderCommonFields(entity: any) {
        const ed = this.getEntityDescriptor();
        return entity ? <div className="flex-container-row flex-center flex-wrap gap3">
            {ed.getField("planeIdentifier").renderField(entity, options)}
            {ed.getField("planeType").renderField(entity, options)}
            {ed.getField("groundAgent").renderField(entity, optionsAsLabel)}
        </div> : null;
    }

    renderTowedInfo(entity: any) {
        const ed = this.getEntityDescriptor();
        return entity ? <div className="flex-container-row flex-center flex-wrap gap3">
            {entity.towedStatus && <Icon color={entity.towedStatus} name='truck' />}
            {ed.getField("towedInitialAddress").renderField(entity, options)}
            {!entity.towedRealStartTime && ed.getField("towedEstimatedStartTime").renderField(entity, options)}
            {ed.getField("towedRealStartTime").renderField(entity, optionsForDate)}
            {entity.towedStatus && <Icon name="arrow right" />}
            {ed.getField("towedAddress").renderField(entity, options)}
            {ed.getField("towedRealEndTime").renderField(entity, optionsForDate)}
        </div> : null;
    }

    renderContent() {
        const { entity } = this.props;
        const arvFlight = entity.departure ? entity.rotationFlight : entity;
        const depFlight = entity.departure ? entity : entity.rotationFlight;
        return <div className="flex-container gap3">
            {this.renderFlight(arvFlight)}
            {this.renderFlight(depFlight)}
            {this.renderCommonFields(entity)}
            {this.renderTowedInfo(entity)}
        </div>
    }
}
